import React, { FC } from 'react';

const DuelWheelProof: FC = () => {
  return (
    <>
      <div style={{ color: '#e5c938' }}>Как работает этот режим?</div>
      <div>
        Варианты аукциона сражаются друг с другом, победивший вариант
        <span style={{ color: '#ff5c36' }}> забирает себе стоимость </span>
        проигравшего и продвигается дальше в турнирной сетке.
        <br />
        (порядок ходов выстроен так, что сначала играется нижняя сетка, затем верхняя)
      </div>
      <div>
        Просто жмите крутить, а дальше разберетесь. Также вы можете поизучать турнирную сетку, нажмите на позицию, чтобы
        проследить весь путь лота.
      </div>
      <div style={{ color: '#e5c938' }}>Сохраняются ли шансы при таком формате?</div>
      <div>
        <span style={{ color: '#59ce4b' }}> Абсолютно точно ДА! </span>
        Шанс лота выграть в этом формате точно такой же как и в обычном колесе, а что самое интересное, нет никакой
        разницы в каком порядке проводятся дуэли, шансы остаются теми же.
      </div>
      <div>У меня пока не было времени оформить пруфы, но скоро я их добавлю.</div>
      <div style={{ color: '#e5c938' }}>Сохраняются ли шансы при группировке лотов?</div>
      <div style={{ color: '#59ce4b' }}> ДА! </div>
      <div>
        Я все это математически просчитывал и симулировал, весь функционал который есть на сайте полностью соответсвует
        обычному колессу по шансам и буквально каждый рубль учитывается в шансах на победу.
      </div>
      <div>Для детального разъяснения можете написать мне в дис (контакты на странице гайда)</div>
    </>
  );
};

export default DuelWheelProof;
